// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","802":"94726e6d","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"3591d39d6227a32b6696","802":"9248795d9a7f3cf28ff7","883":"48d21965cc832adde396"}[chunkId] + ".js";
};